import { render, staticRenderFns } from "./ApprendoLogo.vue?vue&type=template&id=62d106fe&scoped=true"
import script from "./ApprendoLogo.vue?vue&type=script&lang=js"
export * from "./ApprendoLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d106fe",
  null
  
)

export default component.exports